import * as React from 'react';
import {Section, ImageOptions} from 'components/UIKit';
import {NOOP} from 'components/UIKit/utilities';
import {ShopScreenShot} from '../../types';
import {ListingImage, ListingThumbnails} from './components';
import styles from './ListingImages.scss';

export interface ListingImagesProps {
  images: ShopScreenShot[];
  selected: ShopScreenShot;
  altPrefix?: string;
  thumbnailOrientation: 'vertical' | 'horizontal';
  onImageClick?: (image: ShopScreenShot) => void;
  onThumbnailClick: (image: ShopScreenShot) => void;
}

const previewImageOptions: ImageOptions[] = [
  {
    breakpoint: {
      min: null,
      max: 750,
    },
    fallback: true,
    options: {
      format: 'jpg',
      width: 345,
      height: 223,
    },
  },
  {
    breakpoint: {
      min: 751,
      max: 1080,
    },
    options: {
      format: 'jpg',
      width: 531,
      height: 450,
    },
  },
  {
    breakpoint: {
      min: 1081,
      max: null,
    },
    options: {
      format: 'jpg',
      width: 452,
      height: 276,
    },
  },
];

export class ListingImages extends React.Component<ListingImagesProps> {
  handleGalleryImageClick = (id) => {
    const {onImageClick = NOOP, images} = this.props;
    const image = images.find((image) => image.id === id);
    onImageClick(image as ShopScreenShot);
  };

  render() {
    const {images, selected, altPrefix, thumbnailOrientation, onThumbnailClick} = this.props;

    const showEmpty = !selected || !images.includes(selected);
    const showThumbs = images.length > 1;

    return (
      <Section spacing="small" fullWidth className={styles.Container}>
        {!showEmpty && (
          <ListingImage
            id={selected.id}
            type="preview"
            imageUrl={selected.url}
            imageOptions={previewImageOptions}
            onClick={this.handleGalleryImageClick}
          />
        )}
        {showThumbs && (
          <ListingThumbnails
            images={images}
            selected={selected}
            altPrefix={altPrefix}
            orientation={thumbnailOrientation}
            onThumbnailClick={onThumbnailClick}
          />
        )}
      </Section>
    );
  }
}
